/* eslint-disable bsky-internal/avoid-unwrapped-text */
import {useSession} from '#/state/session'
import {useIsMobileWeb} from '#/alf'
import {Button, ButtonText} from '#/components/Button'
import {BodyText, Heading} from '#/wsocial/components/primitives'
import {IllustrationCongrats} from './illustrations'
import {BackButton, IllustrationArea, PageShell} from './primitives'

export function StepCongrats({
  onBack,
  onSkip,
  onNext,
}: {
  onBack?: () => void
  onSkip: () => void
  onNext: () => void
}) {
  const {currentAccount} = useSession()
  const isMobileWeb = useIsMobileWeb()

  const onUpdateProfile = () => {
    if (currentAccount?.handle) {
      sessionStorage.setItem('openEditProfile', '1')
      window.location.replace(`/profile/${currentAccount.handle}`)
    } else {
      onNext()
    }
  }

  return (
    <PageShell>
      <IllustrationArea>
        <IllustrationCongrats />
      </IllustrationArea>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          padding: '24px 16px',
          textAlign: 'center',
        }}>
        <Heading>Congratulations, you&apos;re verified!</Heading>
        <BodyText>
          Take a moment to review your profile and add a photo before you dive
          in.
        </BodyText>
      </div>

      {isMobileWeb ? (
        <div
          style={{
            padding: '16px 16px',
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}>
          <Button
            label="Update profile"
            color="primary"
            size="large"
            testID="updateProfileBtn"
            onPress={onUpdateProfile}
            style={{alignSelf: 'stretch'}}>
            <ButtonText>Update profile</ButtonText>
          </Button>
          <Button
            label="Skip"
            color="secondary"
            size="large"
            testID="skipBtn"
            onPress={onSkip}
            style={{alignSelf: 'stretch'}}>
            <ButtonText>Skip</ButtonText>
          </Button>
        </div>
      ) : (
        <div
          style={{
            padding: '16px 16px',
            display: 'flex',
            alignItems: 'center',
            gap: 10,
          }}>
          {onBack && <BackButton onPress={onBack} />}
          <div
            style={{
              flex: 1,
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 10,
            }}>
            <Button
              label="Skip"
              color="secondary"
              size="large"
              testID="skipBtn"
              onPress={onSkip}>
              <ButtonText>Skip</ButtonText>
            </Button>
            <Button
              label="Update profile"
              color="primary"
              size="large"
              testID="updateProfileBtn"
              onPress={onUpdateProfile}>
              <ButtonText>Update profile</ButtonText>
            </Button>
          </div>
        </div>
      )}
    </PageShell>
  )
}
